import React from "react";
import { Link } from "react-router-dom";
const PageBanner = ({
  pageTitle,
  homePageUrl,
  homePageText,
  activePageText,
}) => {
  return (
    <section className="amit-about-breadcrumb text-center">
      <div className="breadcrumb-bg breadcrumb-bg-about py-5">
        <div className="container py-lg-5 py-md-4">
          <div className="w3breadcrumb-gids">
            <div className="w3breadcrumb-left text-left">
              <h2 className="title AboutPageBanner">{activePageText}</h2>

              {pageTitle && <p className="inner-page-para mt-2">{pageTitle}</p>}
            </div>
            <div className="w3breadcrumb-right">
              <ul className="breadcrumbs-custom-path">
                <li>
                  <Link to={homePageUrl}>
                    <a>{homePageText}</a>
                  </Link>
                </li>
                <li className="active">
                  <span className="fas fa-angle-double-right mx-2"></span>{" "}
                  {activePageText}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hero-overlay"></div>
      </div>
    </section>
  );
};

export default PageBanner;
